// MainLayout.js - Düzeltilmiş Versiyon
import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import Header from "../Header/Header";
import { OrbitLoaderComponent } from "../../utils/orbitLoader";
import "./MainLayout.css";

const MainLayout = ({ onLogout, userData, pageType = "admin" }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [contentKey, setContentKey] = useState(0);
  const location = useLocation();

  // AttendanceFlow modunda mıyız kontrolü
  const isAttendanceFlow = location.pathname === "/employee/attendance";

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  useEffect(() => {
    console.log("MainLayout mounted:", {
      pageType,
      userData,
      location: location.pathname,
    });
  }, []);

  useEffect(() => {
    console.log("Loading started...");
    const timer = setTimeout(() => {
      setIsLoading(false);
      console.log("Loading finished");
    }, 800);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    console.log("Route changed to:", location.pathname);
    setContentKey((prev) => prev + 1);
  }, [location.pathname]);

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="loading-content">
          <OrbitLoaderComponent size="medium" showPath={true} />
          <h3>
            {pageType === "employee" ? "Çalışan Paneli" : "Yönetim Paneli"}
          </h3>
          <p>
            {pageType === "employee"
              ? "Çalışan sistemi yükleniyor..."
              : "Yönetici sistemi yükleniyor..."}
          </p>
        </div>
      </div>
    );
  }

  console.log("MainLayout rendering main content");
  return (
    <div
      className={`main-layout ${pageType} ${
        isAttendanceFlow ? "attendance-fullscreen" : ""
      }`}
    >
      {/* AttendanceFlow modunda Sidebar'ı gizle */}
      {!isAttendanceFlow && (
        <Sidebar
          pageType={pageType}
          isOpen={sidebarOpen}
          toggleSidebar={toggleSidebar}
        />
      )}
      <div className="content-wrapper">
        {/* AttendanceFlow modunda Header'ı gizle */}
        {!isAttendanceFlow && (
          <Header
            onLogout={onLogout}
            userData={userData}
            pageType={pageType}
            toggleSidebar={toggleSidebar}
          />
        )}
        <div
          className={`content ${isAttendanceFlow ? "attendance-content" : ""}`}
          key={contentKey}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
